import React, {Component, Fragment} from 'react';
import OitProgressChart from './OitProgressChart';
import dashboardActionCreators from '../../store/dashboard/action-creators';
import {connect} from 'react-redux';
import reportsActionCreators from '../../store/reports/action-creators';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import {
  reportsDraftFto,
  reportsDueAcknowledgement,
  reportsDueAcknowledgementOit,
  reportsDueApprove,
  reportsDueSubmit,
  reportsWaitingAcknowledgement,
  reportsWaitingApprove,
  reportsWaitingSubmit,
} from '../../store/reports/selectors';
import {CardDeck} from 'reactstrap';
import DashboardTile from './DashboardTile';
import DashboardReports from './DashboardReports';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators';
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import DashboardTasks from "./DashboardTasks";
import taskTrainingActionCreators from "../../store/task-training/action-creators";
import ftoTasksActions from "../../store/ftos/fto-tasks";
import {taskResponsesLateAck, taskResponsesWaitingAck} from "../../store/task-training/selectors";
import Modal from "../../../shared/ui/Modal";
import taskGroupsActions from '../../store/task-groups/action-creators/index';
import AnalyticsBanner from "./AnalyticsBanner";
import DashboardOitReport from "./DashboardOitReport";
import TimeAnalytics from "../analytics/TimeAnalytics";
import DashboardAnalyticsReport from "./DashboardAnalyticsReport";
import DashboardStatisticsReport from "./DashboardStatisticsReport";
import DashboardFtoReport from "./DashboardFtoReport";
import DashboardFtoStatisticsReport from "./DashboardFtoStatisticsReport";
import DashboardLogReport from "./DashboardLogReport";
import DashboardTaskTraining from "./DashboardTaskTraining";
import CommonCreateReport from "../common/CommonCreateReport";
import ReportViewSplit from "../reports/ReportViewSplit";
import ModalSplit from "../../../shared/ui/ModalSplit";

class AppFto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTaskResponseAckLoading: false,
      oitComment: '',
      lateOitComment: '',
      showCreateReportDialog: false,
      deletingDraftReport: null
    };
  }

  componentDidMount() {
    // this.props.fetchReports('fto');
    this.props.fetchAssignedOits();
    this.props.fetchMyTaskResponses();
    this.props.fetchReportsForFtoApprove();
    this.props.fetchTaskGroups();
  }

  openReport(report) {
    this.props.setIsViewingReport(report);
  }

  addReport(report) {
    if (report.status === 'submitted') {
      this.openReport(report)
    } else if (report.status === 'scheduled') {
      this.props.addScheduledReport(report.guid, report.type);
    } else {
      this.props.editReport(report.guid);
    }
  }

  updateComment(oitComment) {
    this.setState({
      oitComment
    })
  }

  updateLateComment(lateOitComment) {
    this.setState({
      lateOitComment
    })
  }

  ackTaskResponse(taskResponse, commentField) {
    let comment = this.state[commentField];
    this.setState({
      isTaskResponseAckLoading: true
    });
    this.props.akcResponse(taskResponse.guid, comment)
      .then(() => {

        this.setState({
          isTaskResponseAckLoading: false,
          [commentField]: ''
        });
      })
  }

  deleteDraftReport() {
    this.props.deleteDraftReport(this.state.deletingDraftReport.guid)
      .then(() => {
        this.setState({
          deletingDraftReport: null
        })
      })
  }

  get isLoading() {
    return (
      this.props.isLoading.includes('fetchAssignedOits') ||
      this.props.isLoadingReports.includes('fetchReports')
    );
  }

  get hasLateSubmitWarnings() {
    return this.props.reportsDueSubmit && this.props.reportsDueSubmit.length;
  }

  get hasLateAckWarnings() {
    return (
      this.props.reportsDueAcknowledgement &&
      this.props.reportsDueAcknowledgement.length
    );
  }

  get hasLateApprovalWarnings() {
    return (
      this.props.reportsDueApprove && this.props.reportsDueApprove.length !== 0
    );
  }

  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Dashboard</h4>
          <p className="sub-title text-muted"><button onClick={() => this.setState({showCreateReportDialog: true})} className="button primary small">Create report</button> Field Training Officer</p>
        </div>
        <div className="app-content dashboard">
          <LoadingOverlay isLoading={this.isLoading}>
            <CardDeck>
              <div style={{ display: 'flex', flex: 1 }}>
                <DashboardTile
                  link="/my-oits"
                  icon="users"
                  title={`My ${this.props.oitShortLabel} Form Progress`}
                  color="#333"
                />
                <DashboardTile
                  link="/task-training"
                  icon="tasks"
                  title={`My ${this.props.oitShortLabel} Task Progress`}
                  color="#333"
                />
                <span />
              </div>
              <div style={{ flex: 1, display: 'flex' }}>
                <DashboardReports
                  showOitName
                  nextReportActive
                  icon="list-alt"
                  viewReportIcon="edit"
                  title="MY ASSIGNED REPORTS"
                  addReportLabel="Complete new form"
                  nextReportLabel="Next report for submission"
                  reports={[...(this.props.reportsWaitingSubmit || []), ...(this.props.reportsWaitingAcknowledgement || [])]}
                  noReportsMessage="No reports pending submission"
                  onViewReport={report => this.addReport(report)}
                />

              </div>
            </CardDeck>

            <div className="dashboard-reports-deck">


              <DashboardReports
                showOitName
                nextReportActive
                icon="warning"
                viewReportIcon="edit"
                title="MY LATE REPORTS"
                nextReportLabel="Next report for submission"
                addReportLabel="Complete late form"
                reports={[...(this.props.reportsDueSubmit || []), ...(this.props.reportsDueAcknowledgement || [])]}
                noReportsMessage="No reports pending submission"
                hasWarnings={this.hasLateSubmitWarnings}
                onViewReport={report => this.addReport(report)}
              />

              <DashboardReports
                showOitName
                hideActions
                icon="warning"
                title={`Late ${this.props.oitShortLabel} acknowledgement`}
                reports={this.props.reportsDueAcknowledgementOit}
                noReportsMessage={`No late reports waiting ${this.props.oitShortLabel} acknowledgement`}
                hasWarnings={this.hasLateAckWarnings}
              />
              <DashboardReports
                showOitName
                nextReportActive
                icon="list-alt"
                viewReportIcon="check"
                title="REPORTS WAITING FOR APPROVAL"
                addReportLabel="Approve"
                nextReportLabel="Next report for approval"
                reports={[...(this.props.reportsDueApprove || []), ...(this.props.reportsWaitingApprove || [])]}
                noReportsMessage="No reports pending my approval"
                onViewReport={report => this.openReport(report)}
              />
            </div>
            {/*<div className="dashboard-reports-deck">*/}


              {/*<DashboardReports*/}
              {/*  showOitName*/}
              {/*  nextReportActive*/}
              {/*  icon="warning"*/}
              {/*  viewReportIcon="check"*/}
              {/*  title="My Late Approvals"*/}
              {/*  nextReportLabel="Next report for approval"*/}
              {/*  addReportLabel="Approve report"*/}
              {/*  reports={[...(this.props.reportsDueApprove || [])]}*/}
              {/*  noReportsMessage="No reports pending my approval"*/}
              {/*  onViewReport={report => this.openReport(report)}*/}
              {/*  hasWarnings={this.hasLateApprovalWarnings}*/}
              {/*/>*/}
            {/*</div>*/}
            <div className="dashboard-reports-deck">
              <DashboardTasks
                icon="tasks"
                taskResponses={this.props.taskResponsesWaitingAck}
                taskGroupsMap={this.props.taskGroupsMap}
                title="Task Acknowledgement"
                isLoading={this.state.isTaskResponseAckLoading}
                ackComment={this.state.oitComment}
                updateComment={this.updateComment.bind(this)}
                onAck={(taskResponse) => this.ackTaskResponse(taskResponse, 'oitComment')}
              />
              <DashboardTasks
                icon="warning"
                taskResponses={this.props.taskResponsesLateAck}
                taskGroupsMap={this.props.taskGroupsMap}
                title="Late Task Acknowledgement"
                isLoading={this.state.isTaskResponseAckLoading}
                ackComment={this.state.lateOitComment}
                updateComment={this.updateLateComment.bind(this)}
                onAck={(taskResponse) => this.ackTaskResponse(taskResponse, 'lateOitComment')}
              />
              <DashboardReports
                showOitName
                nextReportActive
                icon="list-alt"
                viewReportIcon="edit"
                title="OPEN DRAFTS"
                addReportLabel="Complete draft"
                nextReportLabel="Draft report"
                reports={[...(this.props.reportsDraftFto || [])]}
                noReportsMessage="No draft reports"
                onViewReport={report => this.addReport(report)}
                onDeleteReport={report => this.setState({deletingDraftReport: report})}
              />
            </div>
            <AnalyticsBanner />
            <div className="dashboard-reports-deck">
              <DashboardOitReport
                title="View Total Training Hours by Phase & Total Program"
                multiple={true}
              >
                {(oitGuids) => <TimeAnalytics oitGuids={oitGuids}/>}
              </DashboardOitReport>
              <DashboardOitReport
                title="View Remedial Training Minutes by Observation & Phase"
                multiple={true}
              >
                {(oitGuids) => <DashboardAnalyticsReport oitGuids={oitGuids} type="time-spend"/>}
              </DashboardOitReport>
              <DashboardOitReport
                title={`View ${this.props.oitShortLabel} Performance Statistics Against Average`}
                multiple={true}
              >
                {(oitGuids) => <DashboardStatisticsReport oitGuid={oitGuids}/>}
              </DashboardOitReport>
            </div>
            <div className="dashboard-reports-deck">
              <DashboardOitReport
                title={`View ${this.props.oitShortLabel} GRADING ANALYTICS`}
                multiple={true}
              >
                {(oitGuids) => <DashboardAnalyticsReport oitGuids={oitGuids} type="rating" compact={false}/>}
              </DashboardOitReport>
              <DashboardOitReport
                title="VIEW FIELD OCCURRENCE LOG "
                multiple={true}
              >
                {(oitGuids) => <DashboardLogReport oitGuids={oitGuids}/>}
              </DashboardOitReport>
              <DashboardOitReport
                title="View Training Task Progress"
              >
                {(oitGuid) => <DashboardTaskTraining oitGuid={oitGuid}/>}
              </DashboardOitReport>
            </div>
            <OitProgressChart hideTopAxis reverse />
          </LoadingOverlay>
        </div>
        <ModalSplit
          isOpen={!!this.props.viewingReport}
          onClose={() => this.props.setIsViewingReport(null)}
          title={this.props.viewingReport && this.props.viewingReport.formName}
        >
          <ReportViewSplit  report={this.props.viewingReport}/>
        </ModalSplit>
        <Modal
          isOpen={this.state.showCreateReportDialog}
          onClose={() => this.setState({
            showCreateReportDialog: false
          })}
          title={"Create Report"}
          size={'small'}
        >
          {this.state.showCreateReportDialog && (
            <CommonCreateReport onFinish={() => this.setState({showCreateReportDialog: false})} />
          )}
        </Modal>

        <Modal
          isOpen={!!this.state.deletingDraftReport}
          title="Delete draft report"
          onClose={() => this.setState({deletingDraftReport: false})}
        >
          <div className="task-group-activate-modal">
            <h4>Are you sure you want to delete the draft report?</h4>
            <div>
              <button className="button secondary" onClick={() => this.setState({deletingDraftReport: false})}>
                No
              </button>
              <button className="button primary" onClick={() => this.deleteDraftReport()}>
                Yes
              </button>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.dashboard.isLoading,
    isLoadingReports: state.reports.isLoading,
    viewingReport: state.reports.viewingReport,
    reportsWaitingSubmit: reportsWaitingSubmit(state),
    reportsDueSubmit: reportsDueSubmit(state),
    reportsWaitingAcknowledgement: reportsWaitingAcknowledgement(state),
    reportsDueAcknowledgement: reportsDueAcknowledgement(state),
    reportsDueAcknowledgementOit: reportsDueAcknowledgementOit(state),
    reportsDraftFto: reportsDraftFto(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    userContext: state.common.userContext,
    taskResponsesLateAck: taskResponsesLateAck(state),
    taskResponsesWaitingAck: taskResponsesWaitingAck(state),
    reportsWaitingApprove: reportsWaitingApprove(state),
    reportsDueApprove: reportsDueApprove(state),
    taskGroupsMap: state.taskGroups.taskGroupMap
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReports: (scope) => {
      return dispatch(reportsActionCreators.fetchReports(scope));
    },
    fetchReportsForFtoApprove: (scope) => {
      return dispatch(reportsActionCreators.fetchReportsForFtoApprove(scope));
    },
    setIsViewingReport: (report) => {
      return dispatch(reportsActionCreators.setIsViewingReport(report));
    },
    fetchAssignedOits: () => {
      return dispatch(dashboardActionCreators.fetchAssignedOits());
    },
    addScheduledReport: (reportGuid, type) => {
      return dispatch(trainingPhasesActionCreators.addScheduledReport(reportGuid, type));
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    },
    fetchMyTaskResponses: () => {
      return dispatch(ftoTasksActions.fetchFtoTaskResponses());
    },
    akcResponse: (taskResponseGuid, comment) => {
      return dispatch(taskTrainingActionCreators.ackResponse(taskResponseGuid, comment))
    },
    fetchTaskGroups: () => {
      return dispatch(taskGroupsActions.fetchTaskGroups());
    },
    deleteDraftReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteDraftReport(reportGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppFto);
